<template>
  <div style="width: 100%;">
    <div class="row1" id="row1">
      <div class="row1Item">
        <div>打印时间</div>
        <el-date-picker 
          @change="getData" 
          value-format="yyyy-MM-dd"
          v-model="printDate" 
          type="daterange" 
          :range-separator="`至`" 
          :start-placeholder="`开始日期`" 
          :end-placeholder="`结束日期`" 
          >
        </el-date-picker>
      </div>
      <div class="row1Item">
        <div>标签打印数量</div>
        <div>{{total}}</div>
      </div>
      <div class="row1Item">
        <el-button class="ml20" type="primary" size="small" @click="exportImg">导出图表</el-button>
      </div>
    </div>
    <div :style="{height:row2Height}" style="width: 100%;">
      <div class="row2-item">
        <div id="map1"></div>
        <div id="map2"></div>
      </div>
      <div class="row2-item">
        <div id="map3" v-if="showMap3"></div>
        <el-empty v-else :description="`暂无数据`"></el-empty>

        <div id="map4" v-if="showMap4"></div>
        <el-empty v-else :description="`暂无数据`"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import {
  tagPrintCountByDate,
  tagPrintUserWorkload,
  tagPrintInstrumentset,
  tagPrintCount,
} from "@/api.js";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie"; // 引入饼图
import "echarts/lib/chart/bar"; // 引入柱状图
export default {
  data() {
    return {
      printDate: [],
      row2Height: "100px",
      total: 0,
      showMap3: false,
      showMap4: false,
    };
  },
  computed: {
    ...mapGetters(['system'])
  },
  mounted() {
    this.calculateElementHeight();
    this.barMaxWidth = 50;
  },
  async created() {
    await this.calculateData();
    this.getData();
  },
  methods: {
    // 计算默认时间
    calculateData() {
      return new Promise(resolve => {
        const {
          time
        } = this.system
        if (!time) {
          setTimeout(() => {
            resolve(this.calculateData())
          }, 200)
        } else {
          const today = this.$moment(time).format('yyyy-MM-DD')
          const yesterday = this.$moment(time - 86400000).format('yyyy-MM-DD')

          this.printDate = [
            yesterday,
            today,
          ]

          resolve()
        }
      })
    },

    // 计算元素的高度
    calculateElementHeight() {
      const rect = document.getElementById("row1").getBoundingClientRect();
      const row1Height = rect.height;
      const elements = document.getElementsByClassName("layout-page");
      if (elements.length > 0) {
        const rect = elements[0].getBoundingClientRect();
        let height = rect.height - row1Height - 50; // 这个50是边距,包括内边距和外边距
        this.row2Height = height + "px";
      }
    },

    // 获取页面数据
    getData() {
      let query = {};
      if (this.printDate.length != 0) {
        query.start = this.printDate[0];
        query.end = this.printDate[1];
      }
      //每日标签打印数量
      this.$request("get", tagPrintCountByDate, query).then((res) => {
        if (res) {
          if (res) {
            this.paintStackedLineChart(res);
          }
        }
      });
      //人员工作量
      this.$request("get", tagPrintUserWorkload, query).then((res) => {
        if (Array.isArray(res) && res.length == 0) {
          this.showMap3 = false;
        } else {
          this.showMap3 = true;
          this.$nextTick(() => {
            this.printBar1(res);
          });
        }
      });
      //打印器械包数量
      this.$request("get", tagPrintInstrumentset, query).then((res) => {
        if (Array.isArray(res) && res.length == 0) {
          this.showMap4 = false;
        } else {
          this.showMap4 = true;
          this.$nextTick(() => {
            this.printBar2(res);
          });
        }
      });
      //标签打印总数&补打总数
      this.$request("get", tagPrintCount, query).then((res) => {
        if (res) {
          this.total = res.total;
          this.paintPie(res);
        }
      });
    },

    // 打印器械包数量
    printBar2(data) {
      let _this = this;
      let xData = [];
      let seriesData = [];
      for (let key in data) {
        xData.push(key);
        seriesData.push(data[key]);
      }
      let option = {
        title: {
          text: `打印器械包数量`,
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          axisLabel: {
            formatter: function (value) {
              // 格式化刻度标签，将小数部分去除
              if (value % 1 == 0) {
                return value;
              }
            },
          },
        },
        color: ['#AB7DF6'],
        series: [
          {
            data: seriesData,
            type: "bar",
            label: {
              show: true, // 显示标签
              position: "inside", // 标签位置：在柱子内部
              // color: '#fff',
              fontWeight: "bold",
              formatter: function (params) {
                if (params.value[1] !== 0) {
                  return params.value[1];
                } else {
                  return ""; // 数据为零时返回空字符串，不显示标签
                }
              },
            },
            barMaxWidth: _this.barMaxWidth, // 设置最大宽度为20px
          },
        ],
      };
      this.createMap("map4", option);
    },

    // 工作人员工作量
    printBar1(data) {
      let _this = this;
      let newData = [];
      newData.push(["product", `组配人`, `包装人`]);
      for (let key in data) {
        newData.push([
          key.split("_")[0],
          data[key].pack_number,
          data[key].package_number,
        ]);
      }
      let option = {
        title: {
          text: `工作人员工作量`,
        },
        legend: {},
        tooltip: {},
        dataset: {
          source: newData,
        },
        xAxis: {
          type: "category", 
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: {
          axisLabel: {
            formatter: function (value) {
              // 格式化刻度标签，将小数部分去除
              if (value % 1 == 0) {
                return value;
              }
            },
          },
        },
        color: ['#FACA00', '#6FC208'],
        series: [
          {
            type: "bar",
            label: {
              show: true, // 显示标签
              // color: '#fff',
              position: "inside", // 标签位置：在柱子内部
              formatter: function (params) {
                if (params.value[1] !== 0) {
                  return params.value[1];
                } else {
                  return ""; // 数据为零时返回空字符串，不显示标签
                }
              },
            },
            barMaxWidth: _this.barMaxWidth, // 设置最大宽度为20px
          },
          {
            type: "bar",
            label: {
              show: true, // 显示标签
              position: "inside", // 标签位置：在柱子内部
              formatter: function (params) {
                if (params.value[2] !== 0) {
                  return params.value[2];
                } else {
                  return ""; // 数据为零时返回空字符串，不显示标签
                }
              },
            },
            barMaxWidth: _this.barMaxWidth, // 设置最大宽度为20px
          },
        ],
      };
      this.createMap("map3", option);
    },

    //画标签补打记录占比
    paintPie(data) {
      let _this = this;
      let newData = [
        { value: data.add_number, name: `补打数量` },
        { value: data.total - data.add_number, name: `常规打印数量` },
      ];
      let option = {
        title: {
          text: `标签补打记录占比`,
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "6%",
          left: "center",
        },
        color: ['#26C1C9', '#3B7CFF'],
        series: [
          {
            name: `标签补打记录占比`,
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: true, // 显示标签
              position: "inside", // 标签位置：在柱子内部
              fontWeight: "bold",
              formatter: function (params) { // 计算百分比
                if(params.data.value == 0){
                  return ''
                }else{
                  let percentage = (params.data.value / _this.total) * 100;
                  return percentage.toFixed(1) + '%';
                }
                
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: newData,
          },
        ],
      };
      this.createMap("map2", option);
    },

    //画每日标签打印数量变化图：
    paintStackedLineChart(data) {
      let xData = [];
      let data1 = [];
      let data2 = [];
      for (let key in data) {
        xData.push(key);
        data1.push(data[key].add_number);
        data2.push(data[key].number);
      }
      let option = {
        title: {
          text: `每日标签打印数量变化`,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [`补打数量`, `常规打印数量`],
          top:' 6%'
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xData,
        },
        yAxis: {
          axisLabel: {
            formatter: function (value) {
              // 格式化刻度标签，将小数部分去除
              if (value % 1 == 0) {
                return value;
              }
            },
          },
        },
        series: [
          {
            name: `补打数量`,
            type: "line",
            stack: "Total",
            data: data1,
            color: '#26C1C9'
          },
          {
            name: `常规打印数量`,
            type: "line",
            stack: "Total",
            data: data2,
            color: '#3B7CFF'
          },
        ],
      };
      this.createMap("map1", option);
    },

    // 创建echarts表格 的公共函数
    createMap(eleId, option) {
      var myChart = this.$echarts.getInstanceByDom(
        document.getElementById(eleId)
      );

      if (myChart) {
        // 图表实例存在，执行更新操作
        myChart.setOption(option);
      } else {
        // 图表实例不存在，执行创建操作
        myChart = this.$echarts.init(document.getElementById(eleId));
        myChart.setOption(option);
      }
    },

    //点击导出图片
    exportImg() {
      Promise.all(this.getChartImgs())
      .then(res => {
        const sources = res.filter(i => !!i)
        const image = this.combineImg(sources)
        const a = document.createElement('a')
        a.href = image
        a.download = `导出图表.png`
        a.click()
      })
    },
    getChartImgs() {
      const imgListPromise = []
      for (let i = 1; i <= 4; i++) {
        imgListPromise.push(this.generateImgDom(`map${i}`))
      }

      return imgListPromise
    },
    generateImgDom(eleId) {
      return new Promise(resolve => {
        if (document.getElementById(eleId)) {
          var myChart = this.$echarts.getInstanceByDom(
            document.getElementById(eleId)
          )

          const imageData = myChart.getDataURL({
            pixelRatio: 2,
            backgroundColor: "#fff",
          })

          const img = document.createElement("img");
          img.src = imageData;
          resolve(img)
        }

        resolve(null)
      })
    },

    combineImg(source = []) {
      const width = 1000
      const height = 470
      const gap = 20
      const totalHeight = source.length * height + (source.length - 1) * gap
      let paitingHeight = 0

      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      canvas.width = width
      canvas.height = totalHeight

      for (let i = 0; i < source.length; i++) {
        const img = source[i]
        context.drawImage(img, 0, paitingHeight, width, height)
        paitingHeight += (height + gap)
      }

      const image = canvas.toDataURL('img/png')

      return image
    },
  },
};
</script>

<style lang="scss" scoped>
.row1 {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.row1Item {
  display: flex;
  align-items: center;
  div {
    margin-left: 10px;
    margin-top: 5px;
  }
}
.row2-item {
  box-sizing: border-box;
  display: flex;
  height: 50%;
  margin: 10px 0px;
  div {
    width: 50%;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
    box-sizing: border-box;
    margin: 0px 5px;
  }
}
</style>